module.exports = __webpack_public_path__ + "img/icons-7.e791b584.png";